import { useQuery } from '@tanstack/react-query';

import type { JobSummaryType, JobSummaryViewModel } from '../model';

import { jobImprovedSelectionClient } from './client';
import { toJobSummaryViewModel } from '../model';
import { QueryKey } from '@/types/query';

const staleTimeMs = 5 * 60 * 1000;
const cacheTimeMs = 5 * 60 * 1000;

export type UseJobImprovedListQueryParams = {
  search?: string;
  type?: JobSummaryType[];
  enabled?: boolean;
};

export const useJobImprovedListQuery = ({ search, type, enabled }: UseJobImprovedListQueryParams = {}) => {
  return useQuery<JobSummaryViewModel[]>({
    queryKey: [QueryKey.useJobImprovedListQuery, search ?? '', type],
    queryFn: async () => {
      const { data } = await jobImprovedSelectionClient.listJobSummaries(search, type);
      return data.map(toJobSummaryViewModel);
    },
    keepPreviousData: true,
    cacheTime: cacheTimeMs,
    staleTime: staleTimeMs,
    initialData: [],
    initialDataUpdatedAt: 0,
    enabled,
    retry: false,
  });
};
